import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/commons/generic.service';
import { EnderecoPosRecadDTO } from 'app/components/pos-recadastramento/aba5-posrecad/enderecoPosRecad.dto';
import { environment } from 'environments/environment';
import { ArquivoBlobDTO } from 'app/model/arquivoBlob.dto';


@Injectable()
export class PosCampanhaServiceAba6 extends GenericService {


  private baseUrl = environment.url + 'api/v1/';

  constructor(http: HttpClient) {
    super(http);
  }

  getObterTrabalhadorEstrangeiro(param): Observable<any> {
    return this.getMethod<any>(`api/v1/admin/validacao-recadastramento/trabalhador-estrangeiro`, { validacaoRecadId: param });
  }

  postDadosTrabalhadorEstrangeir(body): Observable<any> {
    return this.http.post<any>(this.baseUrl + `admin/validacao-recadastramento/trabalhador-estrangeiro`, body);
  }

  getArquivoTrabalhadorEstrangeiro(param): Observable<any> {
    const options = {
      recadValidacaoEnderecoId: param,
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>(this.baseUrl + `admin/validacao-recadastramento/trabalhador-estrangeiro/anexo?recadValidacaoTrabEstId=${param}`, options);
  }

  
}
